import React, { useState, useRef } from 'react';
import { Zap, Boxes } from 'lucide-react';
import NodePaletteModal from './NodePaletteModal';

const NAV_ITEMS = [
  { id: 'trigger', label: 'Triggers', icon: Zap },
  { id: 'action', label: 'Actions', icon: Boxes },
];

export default function NodePalette() {
  const [activeTab, setActiveTab] = useState(null);
  const navRefs = useRef({});

  const handleTabClick = (tabId) => {
    setActiveTab((prev) => (prev === tabId ? null : tabId));
  };

  const handleClose = () => setActiveTab(null);

  return (
    <>
      <div className="w-14 border-r border-gray-100 bg-white flex flex-col items-center pt-3 gap-1 flex-shrink-0">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              ref={(el) => { navRefs.current[item.id] = el; }}
              onClick={() => handleTabClick(item.id)}
              className={`w-11 flex flex-col items-center gap-0.5 px-1 py-2 rounded-lg text-[10px] font-medium transition-colors ${
                isActive
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-400 hover:bg-gray-50 hover:text-gray-600'
              }`}
            >
              <Icon className="w-4 h-4" strokeWidth={2} />
              {item.label}
            </button>
          );
        })}
      </div>

      {activeTab && (
        <NodePaletteModal
          category={activeTab}
          anchorEl={navRefs.current[activeTab]}
          onClose={handleClose}
        />
      )}
    </>
  );
}
